import { render, staticRenderFns } from "./VerticalNavMenuHeader.vue?vue&type=template&id=2df83336&scoped=true"
import script from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuHeader.vue?vue&type=style&index=0&id=2df83336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df83336",
  null
  
)

export default component.exports